import {
  Button,
  ButtonProps,
  DrawerFooter,
  ModalFooterProps,
} from "@chakra-ui/react";

export type DrawerFormFooterProps = ModalFooterProps & {
  cancelButtonProps?: ButtonProps;
  formId: string;
  onClose: () => void;
  submitButtonProps?: ButtonProps;
};

export default function DrawerFormFooter({
  cancelButtonProps,
  children,
  formId,
  onClose,
  submitButtonProps,
  ...rest
}: DrawerFormFooterProps) {
  return (
    <DrawerFooter {...rest}>
      <Button
        type="button"
        onClick={onClose}
        variant="ghost"
        mr={4}
        {...cancelButtonProps}
      >
        Cancel
      </Button>

      {children}

      <Button
        type="submit"
        colorScheme="pinkButton"
        form={formId}
        {...submitButtonProps}
      >
        {submitButtonProps?.children || "Save"}
      </Button>
    </DrawerFooter>
  );
}
